import React from 'react';
import MuiLink from '@mui/material/Link';
import { Link as GatsbyLink } from 'gatsby';

const Link = React.forwardRef(function Link(props, ref) {
    return <MuiLink
        sx={{
            textDecoration: 'none',
            '&:hover': {
                textDecoration: 'underline',
            },
        }}
        component={GatsbyLink}
        ref={ref}
        {...props}
    />;
});

export default Link;
